import { createContext, useState } from "react";

import {
  CompanyShort,
  ICompanyObject,
  ICompanyUser,
  IObveznikGrupe,
  ITipObjekta,
  IUserDetails,
} from "./settings.types";

interface SettingContextState {
  companyUsers: ICompanyUser[];
  companyObjects: CompanyShort[];
  selectedUser: IUserDetails | null;
  objectTypes: ITipObjekta[];
  selectedObject: ICompanyObject | null;
  obveznikRoles: IObveznikGrupe[];
}

export type UpdateSettingsStateFunction = (
  updatedState: Partial<SettingContextState>
) => void;

export interface ModalContextProviderProps {
  children: JSX.Element;
}

const initialState = (): SettingContextState => ({
  companyUsers: [],
  companyObjects: [],
  objectTypes: [],
  selectedUser: null,
  selectedObject: null,
  obveznikRoles: [],
});

export const SettingsContext = createContext<{
  settings: SettingContextState;
  setSettings: UpdateSettingsStateFunction;
  clearSettings: () => void;
}>(null as any);

export const SettingsContextProvider = ({
  children,
}: ModalContextProviderProps) => {
  const [settings, setSettings] = useState(initialState());

  const handleSetSettings = (updatedState: Partial<SettingContextState>) => {
    setSettings((prev) => ({ ...prev, ...updatedState }));
  };

  const setSettingsState = (updatedState: Partial<SettingContextState>) => {
    handleSetSettings({ ...updatedState });
  };

  const clearSettings = () => {
    setSettings(initialState());
  };

  return (
    <SettingsContext.Provider
      value={{
        settings,
        setSettings: setSettingsState,
        clearSettings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};
